// extracted by mini-css-extract-plugin
export default {"root":"_3gjwf","label":"_2yJww","value":"_22J2Z"};